export default "__VITE_ASSET__Dtm4ZJyH__"